import React from 'react';
import PropTypes from 'prop-types';

import Title from '../../components/Title';
import Layout from '../../components/Layout';

const MainLayout = ({ children, shopName }) => (
  <Layout shopLayout>
    <Title>{ shopName }</Title>
    <div className="u-pt">
      { children }
    </div>
  </Layout>
);

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  shopName: PropTypes.string,
};

MainLayout.defaultProps = {
  shopName: '',
};

export default MainLayout;



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardLayout/GiftCardLayout.jsx